/**
 * @generated SignedSource<<fa88f1819d074a1270ec0472c74a97b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TutorialTeamHealth_flags$data = {
  readonly flags: ReadonlyArray<string | null> | null;
  readonly " $fragmentType": "TutorialTeamHealth_flags";
};
export type TutorialTeamHealth_flags$key = {
  readonly " $data"?: TutorialTeamHealth_flags$data;
  readonly " $fragmentSpreads": FragmentRefs<"TutorialTeamHealth_flags">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TutorialTeamHealth_flags",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flags",
      "storageKey": null
    }
  ],
  "type": "Flags",
  "abstractKey": null
};

(node as any).hash = "22efe84c32cdd0039a50a06650c357b7";

export default node;
